import React, {ReactElement} from 'react';

import Calculator from '@fo/components/BusinessLoanCalculator/Calculator/Calculator';
import Vimeo from './Vimeo/Vimeo';
import YouTube from './YouTube/YouTube';

export enum EmbeddableAssetType {
  VIMEO = 'vimeo',
  YOUTUBE = 'youtube',
  BLC = 'business-loan-calculator',
}

interface Props {
  title?: string;
  type: EmbeddableAssetType;
  url: string;
}

function EmbeddableAsset({title, type, url}: Props): ReactElement | null {
  // @todo extend this switch statement as we add more types of content
  switch (type) {
    case EmbeddableAssetType.VIMEO:
      return <Vimeo url={url} title={title} />;

    case EmbeddableAssetType.YOUTUBE:
      return <YouTube url={url} title={title} />;

    case EmbeddableAssetType.BLC:
      return <Calculator />;

    default:
      return null;
  }
}

export default EmbeddableAsset;
